<script>


    import { onMount } from 'svelte';
    import { drawerOpen } from '../../store.js';
    import {itemClick} from './../../../../igen-shared-js/common.js'
    import Icon from './../../icons/Icon.svelte';
    export let links;

    onMount((()=>{

        console.log(links)

    }))

    async function drawerMenuClick(link) {
        console.log(link);
        let triggerCloseBefore = false;

        if(link.value._class && link.value._class.toLowerCase()==='action_websiteexternal'){
            triggerCloseBefore = true;
            console.log('drawerfix external');
        }

        if(link.value._class && link.value._class.toLowerCase()==='action_website'){
            if(link.value.isExternalAction){
                triggerCloseBefore = true;
                console.log('drawerfix website external');
            }
        }

        try{
            itemClick(link);
        }catch(e){
            console.log('menu click issue',e);
        }
        if(!triggerCloseBefore){
            drawerOpen.set(false);
        }
   
    }

</script>

<div class="sidebar {$drawerOpen === true ? 'open' : ''}" >
    <ul>  
        {#each links as link}
            <li on:mousedown={()=>{drawerMenuClick(link);}}>
                <div class="icon">
                   <Icon {link}/>
                </div>
                <div class="label">{link.title}</div>
                <div class="chevron"></div>
            </li>    
        {/each}
    </ul>
</div>

<style>

.sidebar{
    position: absolute;
    height: 100%;
    min-height: 100%;
    width:250px;
    top: 0;
    left: 0;
    overflow-x: hidden; 
    transform: translate3d(-251px, 0px, 0px) scale(1);
    transition-duration: 200ms;
    background-color:var(--user-dark-color);
    color:#fff;
    box-sizing: border-box;
}

.open{
    transform: translate3d(0px, 0px, 0px) scale(1);
}

ul{
    margin:0;
    padding:0;
    width:250px;
}

li{

    display:flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    margin:0;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    background-color: transparent;
    height:50px;
    color: #fff;
    width:250px;
}

li:focus,li:active {
    background-color: var(--user-color);
}

.icon{
    width:35px;
    margin: 5px;
    fill: #fff;
}

:global(.sidebar .icon svg){
        margin: 0!important;
}

.chevron{
    width:30px;
}

.label{
    width: calc(100% - 60px);
}

:global(.sidebar .km-icon){
    font-size: 1.4em;
}

</style>